import { createScrollToContext } from '@orthly/ui';

export const {
    Provider: CheckoutScrollToProvider,
    useContainer: useCheckoutScrollToContainer,
    useControl: useCheckoutScrollToControl,
} = createScrollToContext();
